import type { TranslationKey } from './i18n/translations';

/** Dienste aus dem Servicekatalog; `value` entspricht dem in Professional-Profilen gespeicherten Namen. */
export const serviceOptions = [
  { value: 'Massage', labelKey: 'service.massage' },
  { value: 'Kite Lesson', labelKey: 'service.kiteLesson' },
  { value: 'Wingfoil Lesson', labelKey: 'service.wingfoilLesson' },
  { value: 'Yoga', labelKey: 'service.yoga' }
] satisfies Array<{ value: string; labelKey: TranslationKey }>;

/** Bekannte Orte der Pilotregion mit Koordinaten für Suche und Registrierung. */
export const regionOptions = [
  { id: 'cumbuco-beach', label: 'Cumbuco Beach', detailKey: 'search.townCenter', lat: -3.6262, lng: -38.7279 },
  { id: 'cumbuco-village', label: 'Cumbuco Village', detailKey: 'search.village', lat: -3.6252, lng: -38.7251 },
  { id: 'cauipe-lagoon', label: 'Cauipe Lagoon', detailKey: 'search.lagoon', lat: -3.6025, lng: -38.7793 }
] satisfies Array<{ id: string; label: string; detailKey: TranslationKey; lat: number; lng: number }>;
